module.exports = __webpack_public_path__ + "b5ac17604b6b9d18e51fe61b50c91b38.svg";